module.exports = __webpack_public_path__ + "kh.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/kh.svg
// module id = 636
// module chunks = 0